// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import axios from 'axios'

import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import formCreate from '@form-create/element-ui'
Vue.use(formCreate)
Vue.use(Element)

// axios.defaults.baseURL = 'http://192.168.123.240:10901'//测试
// axios.defaults.baseURL = 'https://publicapi.houbaoyan.cn'//线上
//post请求，使用 form data 的形式进行交互，千万要这样写！！！！！！ ios 使用POST 必备哦！
let API_URL
if (process.env.NODE_ENV === 'development') {
  API_URL = 'http://192.168.88.106:10901'
} else if (process.env.NODE_ENV === 'production') { // 线上
  API_URL = 'https://publicapi.houbaoyan.cn'
}
axios.defaults.baseURL = API_URL
axios.defaults.headers.post = {
  "Content-Type": "application/x-www-form-urlencoded"
}
axios.defaults.headers.get = {
  "Content-Type": "application/x-www-form-urlencoded"
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js